// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Index_cardWrapper__q92F_","price":"Index_price__3yVeZ"};